import { EnvelopeIcon } from '@heroicons/react/20/solid';
import { capitalizarPalabras } from '../../common/upperCaseWord';
import { Avatar } from './Avatar';
import './Avatar.css';

/**
 * Fila de persona: avatar + nombre, rol opcional y meta (p. ej. correo).
 */
export const PersonSummary = ({
    name,
    firstName,
    lastName,
    initials,
    role,
    meta,
    youBadge,
    avatarSize = 'md',
    status,
    statusLabel,
    variant = 'inline',
    className = '',
}) => {
    const rawName = name || [firstName, lastName].filter(Boolean).join(' ');
    const displayName = capitalizarPalabras(rawName);
    const metaText = typeof meta === 'string' ? meta.trim() : '';

    return (
        <div className={`person-summary${variant === 'card' ? ' person-summary--card' : ''}${className ? ` ${className}` : ''}`}>
            <Avatar
                size={avatarSize}
                name={rawName}
                firstName={firstName}
                lastName={lastName}
                initials={initials}
                status={status}
                statusLabel={statusLabel}
            />
            <div className="person-summary__content">
                <span className="person-summary__name">
                    {displayName}
                    {youBadge ? (
                        <span className="person-summary__you">{youBadge}</span>
                    ) : null}
                </span>
                {role ? (
                    <span className="person-summary__role">{role}</span>
                ) : null}
                {metaText ? (
                    <span className="person-summary__meta">
                        <EnvelopeIcon className="person-summary__meta-icon" aria-hidden="true" />
                        <span className="person-summary__meta-text">{metaText}</span>
                    </span>
                ) : null}
            </div>
        </div>
    );
};
